<template>
  <div>
    <div class="kLine" v-if="!empty">
      <KLineHead :kLineData="kLineData" :showMask.sync="showMask"></KLineHead>
      <KLineMain
        :kLineData="kLineData"
        v-if="Object.keys(kLineData).length !== 0"
      ></KLineMain>
    </div>
    <div v-else>
      <van-empty mode="list" icon="http://cdn.uviewui.com/uview/empty/car.png">
      </van-empty>
    </div>
    <ShareMask v-show="showMask" :showMask.sync="showMask"></ShareMask>
  </div>
</template>

<script>
import KLineHead from "./kLineHead";
import KLineMain from "./kLineMain";
import { getkLine } from "@/api/market";
import ShareMask from "./mask";
export default {
  components: { KLineHead, KLineMain, ShareMask },
  data() {
    return {
      kLineData: {},
      empty: false,
      showMask: false,
    };
  },
  created() {
    const id = this.$route.query.id;
    getkLine({ id, minute: 5 }).then((res) => {
      this.kLineData = res.data.data;
      this.empty = this.kLineData == null ? true : false;
    });
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.kLine {
  height: 100vh;
}
</style>
